import React, { useState, useEffect } from 'react';
import { makeStyles } from "@mui/styles";
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import { notificationTypes } from '../../Config/constants';
import { toDateFormatWithoutT } from '../../Helpers/dateHelper';
import { useTranslation } from 'react-i18next';

export default function MessageContent(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    const [message, setMessage] = useState(props.message);
    const [splitMessage, setSplitMessage] = useState([]);

    useEffect(() => {
        if (props.message !== undefined) {
            const parsedMetaData = JSON.parse(props.message.MetaData);

            const updatedMessage = {
                ...props.message,
                metaData: parsedMetaData[0].MetaData[0], // Add the parsed metadata for easy access
            };
            // Set the updated message in state
            setMessage(updatedMessage);
            setSplitMessage(updatedMessage.Message.split(" "));
        }
    }, [props.message]);

    let iconColor = "";
    let icon = <React.Fragment></React.Fragment>;
    let borderLeft = "";

    switch (props.message.NotificationTypeId) {
        case notificationTypes.MACHINESTART:
        case notificationTypes.CLEANING:
            iconColor = "#5CC958";
            icon = <InfoIcon className={classes.infoIcon}></InfoIcon>;
            borderLeft = "solid 8px rgb(92,201,88,0.2)";
            break;
        case notificationTypes.PROBLEM:
        case notificationTypes.MACHINESTOP:
            iconColor = "#D84949";
            icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
            borderLeft = "solid 8px rgb(216,73,73,0.2)";
            break;
        case notificationTypes.MACHINESTANDBY:
            iconColor = "#F59127";
            icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
            borderLeft = "solid 8px rgb(245, 145, 39,0.2)";
            break;
        default:
    }

    return (
        <div className={classes.messageContainer} key={props.id}>
            <div className={classes.dateTime}>
                {toDateFormatWithoutT(props.message.InsertedOn)}
            </div>
            <div className={classes.message} style={{ borderLeft: borderLeft, backgroundColor: props.backgroundColor }}>
                <div className={classes.icon} style={{ color: iconColor, paddingTop: props.iconPadding }}>{icon}</div>
                <div className={classes.textContainer}>
                    {!message.MetaData.CustomMessage && <div className={classes.text} style={{ width: props.textWidth }}>{t(message.Message.split(" ").slice(0, -1).join(" ")) + " " + message.Message.split(" ").pop()}</div>}
                    {message.MetaData.CustomMessage && <div className={classes.text} style={{ width: props.textWidth }}>{t(message.MetaData.CustomMessage)}</div>}
                </div>
            </div>
        </div>
    )
}

const useStyles = makeStyles(() => ({
    icon: {
        float: "left",
        marginRight: "20px"
    },
    text: {
        float: "left",
        paddingTop: "3px"
    },
    message: {
        width: "100%",
        borderRadius: "6px",
        paddingTop: "10px",
        boxSizing: "border-box",
        paddingLeft: "10px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: '#020100',
        overflow: "auto",
        paddingBottom: "10px",
        minHeight: "65px"
    },
    dateTime: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: '#8D8D8D',
        marginTop: "10px"
    }
}));